export const AUTH_CONSTANTS = {
   RECONNECT_BATCH_LIMIT: 3,
   RECONNECT_RETRY_GAP: 2000,
   RECONNECT_LONG_GAP: 30000,
};
